import React from "react";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import { withTranslation } from "react-i18next";

import axios from "../../components/Axios";
import { CompactSelect } from "./ui";

const FEATURES = ["Actions", "Logos", "Nudity", "Speech"];
const NAME_AREAS = [
  ["account", "All videos in account"],
  ["folder", "All videos in same folder"],
  ["video", "Video itself only"],
];
const LANGUAGES = [
  ["auto", "Auto Detect"],
  ["en", "English"],
  ["fr", "French"],
  ["es", "Spanish"],
  ["de", "German"],
];
const IS_DEV = (process.env.REACT_APP_ENV || "").startsWith("dev");

// Account > Video Settings: character recognition and drag-and-drop upload defaults.
// Both cards save the same settings object.
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      errorMessage: "",
      celebrity_recognition: true,
      character_name_area: "account",
      language: "auto",
      multi_language: false,
      features: ["Actions", "Logos", "Nudity", "Speech"],
      dev_params: '{"asr_version": "large-v3"}',
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.getItems();
  }

  async getItems() {
    this.setState({ loading: true });
    let resp = await axios.get("/user/settings");
    this.setState({
      loading: false,
      ...resp.data,
    });
    let dev_params = localStorage.getItem("dev_params");
    if (dev_params != null) {
      this.setState({ dev_params: dev_params });
    }
  }

  handleChange(e) {
    let v = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: v });
  }

  toggleFeature(f) {
    this.setState((s) => ({
      // keep the canonical order
      features: s.features.includes(f) ? s.features.filter((x) => x !== f) : FEATURES.filter((x) => x === f || s.features.includes(x)),
    }));
  }

  saveItem = async () => {
    this.setState({ loading: true });
    localStorage.setItem("dev_params", this.state.dev_params); //save dev params
    let resp = await axios.post("/user/settings", this.state);
    this.setState({
      loading: false,
      ...resp.data,
    });
    window.dispatchEvent(new CustomEvent("app-success", { detail: "Settings saved successfully!" }));
  };

  render() {
    const { t } = this.props;
    const { loading } = this.state;
    const tr = (options) => options.map(([v, label]) => [v, t(label)]);
    const save = (
      <div className="ac-foot">
        <Button className="Button ButtonPrimary ac-btn" onClick={this.saveItem} disabled={loading}>
          {t("Save")}
        </Button>
      </div>
    );

    return (
      <div className="ac-grid">
        <section className="ac-card ac-w2" aria-labelledby="ac-characters-h">
          <div className="ac-head">
            <h2 id="ac-characters-h" className="ac-title">
              {t("Character Recognition")}
            </h2>
          </div>
          <div className="ac-body">
            <FormControlLabel
              className="ac-check"
              control={<Checkbox checked={!!this.state.celebrity_recognition} name="celebrity_recognition" color="primary" onChange={this.handleChange} />}
              label={t("Celebrity Recognition for talking characters")}
            />
            <div className="ac-row">
              <label htmlFor="ac-name-area" className="ac-label">
                {t("Get Character Names from")}
              </label>
              <CompactSelect
                id="ac-name-area"
                name="character_name_area"
                value={this.state.character_name_area}
                onChange={this.handleChange}
                options={tr(NAME_AREAS)}
              />
            </div>
          </div>
          {save}
        </section>

        <section className="ac-card ac-w3" aria-labelledby="ac-upload-h">
          <div className="ac-head">
            <h2 id="ac-upload-h" className="ac-title">
              {t("Upload Settings for Drag and Drop")}
            </h2>
          </div>
          <div className="ac-body" style={{ gap: "10px" }}>
            <div className="ac-row">
              <label htmlFor="ac-language" className="ac-label">
                {t("Desired Transcript Language")}
              </label>
              <div className="ac-inline">
                <CompactSelect
                  id="ac-language"
                  name="language"
                  value={this.state.language}
                  onChange={this.handleChange}
                  options={tr(LANGUAGES)}
                  style={{ flex: "0 1 200px" }}
                />
                <FormControlLabel
                  className="ac-check"
                  control={<Checkbox checked={!!this.state.multi_language} name="multi_language" color="primary" onChange={this.handleChange} />}
                  label={t("Multi Language")}
                />
              </div>
            </div>

            <div className="ac-row ac-top">
              <span id="ac-features-l" className="ac-label">
                {t("Features")}
              </span>
              <div className="ac-stack">
                <div className="ac-pills" role="group" aria-labelledby="ac-features-l">
                  {FEATURES.map((f) => {
                    const on = this.state.features.includes(f);
                    return (
                      <button key={f} type="button" className="ac-pill" aria-pressed={on} onClick={() => this.toggleFeature(f)}>
                        {on ? <CheckIcon /> : <AddIcon />}
                        {t(f)}
                      </button>
                    );
                  })}
                </div>
                <p className="ac-help">{t("Deselect features for faster processing time")}</p>
              </div>
            </div>

            {IS_DEV && (
              <div className="ac-row">
                <label htmlFor="ac-dev-params" className="ac-label">
                  Dev Parameters <span className="ac-kind">dev</span>
                </label>
                <input
                  id="ac-dev-params"
                  name="dev_params"
                  type="text"
                  className="ac-input ac-mono ac-wide"
                  value={this.state.dev_params}
                  onChange={this.handleChange}
                />
              </div>
            )}
          </div>
          {save}
        </section>
      </div>
    );
  }
}

export default withTranslation()(Index);
